module.exports = __webpack_public_path__ + "img/empilhadeiras_pag7_SMALL.ded3b3ad.jpeg";